function AddWithdrawn() {
    return (
      <>
        <div className="font-bold text-lg mb-16">AddWithdrawn</div>
      </>
    );
  }
  
  export default AddWithdrawn;